<div fxLayout="row" fxLayoutAlign="center center">
	<div class="pt-40" fxLayout="column" fxFlex="30%" fxFlex.sm="80%" fxFlex.md="80%" fxFlex.xs="90%"
		fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
		<h1 i18n="@@update-your-profile-header" name="update-your-profile-header">
			<b>Update your profile</b>
		</h1>
		<mat-card fxLayout="row wrap" fxLayoutAlign="center center" class="mat-elevation-z4">
			<mat-card-content fxFlex="90%" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
				<form fxLayout="column" [formGroup]="personalDetailsForm" (submit)="submitPersonalDetails()">
					<mat-form-field>
							<mat-label i18n="@@personal-details-firstName" name="personal-details-firstName">First Name</mat-label>
							<input matInput formControlName="firstName" [(ngModel)]="currentFirstName" maxlength="64" noWhiteSpaces required>
						<mat-error i18n="@@firstName-required" name="firstName-required"
							*ngIf="firstName.errors?.required">
							First name is required.
						</mat-error>
						<mat-error i18n="@@firstName-validation" name="firstName-validation"
							*ngIf="firstName.errors?.pattern">
							Invalid First Name input
						</mat-error>
						<mat-error i18n="@@firstName-character-length" name="firstName-character-length"
							*ngIf="firstName.errors?.minlength || firstName.errors?.maxlength">
							The field first name must be between 2 and 64 characters.
						</mat-error>
					</mat-form-field>
					<mat-form-field>
							<mat-label i18n="@@personal-details-lastName" name="personal-details-lastName">Last Name</mat-label>
							<input matInput formControlName="lastName" [(ngModel)]="currentLastName" maxlength="64" noWhiteSpaces required>
						<mat-error i18n="@@lastName-required" name="lastName-required"
							*ngIf="lastName.errors?.required">
							Last name is required.
						</mat-error>
						<mat-error i18n="@@lastName-validation" name="lastName-validation"
							*ngIf="lastName.errors?.pattern">
							Invalid Last Name input
						</mat-error>
						<mat-error i18n="@@lastName-character-length" name="lastName-character-length"
							*ngIf="lastName.errors?.minlength || lastName.errors?.maxlength">
							The field last name must be between 2 and 64 characters.
						</mat-error>
					</mat-form-field>
					<mat-form-field>
						<input matInput value="{{currentEmail}}" name="currentEmail" readonly>
					</mat-form-field>
					<mat-form-field>
						<mat-label i18n="@@new-email" name="new-email">New Email</mat-label>
						<input matInput formControlName="newEmail" maxlength="320" noWhiteSpaces readonly>
							<mat-error i18n="@@email-validation" name="new-email-validation" *ngIf="newEmail.errors?.email || newEmail.errors?.pattern">
							Please enter a valid email address.
						</mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label i18n="@@confirm-email" name="confirm-email">Confirm Email</mat-label>
						<input matInput formControlName="confirmEmail" maxlength="320" noWhiteSpaces readonly>
							<mat-error i18n="@@email-validation" name="confirm-email-validation" *ngIf="confirmEmail.errors?.email || confirmEmail.errors?.pattern">
							Please enter a valid email address.
						</mat-error>
							<mat-error i18n="@@email-mismatch" name="email-mismatch" *ngIf="confirmEmail.errors?.emailMismatch">
								The email entry fields do not match. Please enter the same email in both fields and try again.
						</mat-error>
					</mat-form-field>
					<ng-container *ngIf="userProfile?.roleId == 5">
						<h2 class="pt-10" i18n="@@more-details-title" name="more-details-title">More Details
						</h2>
						<mat-form-field>
							<mat-label i18n="@@organisationID" name="learner-number02">Organisation ID
								(LN02)</mat-label>
							<input matInput formControlName="learnerNumber02" noWhiteSpaces readonly disabled>
						</mat-form-field>
						<mat-form-field>
							<mat-label i18n="@@globally-uniqueID" name="unique-learner-number">Globally Unique ID
								(ULN)</mat-label>
							<input matInput formControlName="uniqueLearnerNumber" noWhiteSpaces readonly disabled>
						</mat-form-field>
					</ng-container>
					<div fxLayoutAlign="end end">
						<button i18n="@@btnSave" name="personal-details-btnSave" mat-raised-button [class.spinner]="loading"
							[disabled]="loading" color="primary" type="submit">Save</button>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</div>
</div>
